import React, { Component } from "react";
import { Growl } from "primereact/growl";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import subMonths from "date-fns/subMonths";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import * as appConst from "../../Common/constants";
import moment from "moment";

export default class Edit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: this.props.name,
      _id: this.props.pData._id,
      patientname: this.props.pData.patientname,
      qty: this.props.pData.qty,
      outdate: this.props.pData.outdate,
      indate: ""
    };

    this.handleInDateChange = this.handleInDateChange.bind(this);
  }

  render() {
    return (
      <div>
        <h5 align="center">Return Equipment</h5>
        <div className="container-fluid">
          <div className="row p-1 border">
            <div className="col col-md-2">Equipment Name</div>
            <div className="col col-md-3">: {this.state.name}</div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">Patient</div>
            <div className="col col-md-3">: {this.state.patientname}</div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">Quantity</div>
            <div className="col col-md-3">: {this.state.qty}</div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">Out Date</div>
            <div className="col col-md-3">
              : {this.dateFormatter(this.state.outdate)}
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">Return Date</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.indate}
                onChange={this.handleInDateChange}
                dateFormatCalendar={"MMM yyyy"}
                minDate={subMonths(new Date(), 10)}
                maxDate={new Date()}
                showMonthYearDropdown
                dateFormat="dd-MMM-yyyy"
                width="300px"
                className="p-error"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <button
              onClick={this.onSaveClick}
              className="btn btn-primary btn-md mr-2"
            >
              Save
            </button>

            <button
              onClick={this.onCancelClick}
              className="btn btn-primary btn-md mr-2"
            >
              Cancel
            </button>
          </div>
          <Growl ref={el => (this.growl = el)} />
        </div>
      </div>
    );
  }

  handleInDateChange(indate) {
    this.setState({ indate });
  }

  onSaveClick = async e => {
    e.preventDefault();

    if (this.state.indate !== "") {
      const obj = {
        _id: this.state._id,
        indate: this.state.indate,
        eno: this.props.eno,
        qty: this.state.qty
      };

      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
            
            "/equipment/return",
          obj
        )
        .then(res => {
          this.props.onClick("List", null, this.props.name, this.props.eno);
        })
        .catch(error => {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Something went wrong !!"
          });
        });
    } else {
      this.growl.show({
        severity: "error",
        summary: "Error !!",
        detail: "Select Return Date !!"
      });
    }
  };

  dateFormatter(dt) {
    var arr = dt.split("-");
    return (
      arr[2].substring(0, 2) +
      "-" +
      moment(dt.toString()).format("MMM") +
      "-" +
      arr[0]
    );
  }

  ClearData() {
    this.setState({ expType: "", hasNameError: true });
  }

  onClearClick = e => {
    this.ClearData();
    this.growl.show({
      severity: "success",
      summary: "Success",
      detail: "Data Cleared !!!"
    });
  };

  onCancelClick = e => {
    this.props.onClick("List", null, this.props.name, this.props.eno);
  };
}
